import { combineReducers } from 'redux';
import AppReducer from './AppReducer';
import MsgReducer from './MsgReducer';
import PresenceReducer from './PresenceReducer';

const RootReducer = combineReducers({
  AppReducer,
  MsgReducer,
  PresenceReducer,
});

export default RootReducer;
